import React from "react";
// import "./Section.css";

function Section(props) {
  return <h5 style={{ color: "#3ab449" }}>{props.text}</h5>;
}
export default Section;
